/* Página atualizada e funcionando

Essa parte de layouts serve para chamar o código que está em pages, onde tudo é realmente montado.

*/

import PenTest from "pages/Servicos/Penetration";

export default function PenetrationPage() {
  return <PenTest />;
}
